import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=137c6ca4&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=137c6ca4&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137c6ca4')) {
      api.createRecord('137c6ca4', component.options)
    } else {
      api.reload('137c6ca4', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=137c6ca4&", function () {
      api.rerender('137c6ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Main.vue"
export default component.exports